import useSWRMutationForm, { useErrorToSnackbar } from 'common-form/useSWRMutationForm';
import { useState } from 'react';
import usePrequal from '../../resources/prequal/usePrequal';
import useApplication from '../../resources/applications/read';
import useSignDocument from '../../resources/documents/sign';

const useForm = () => {
  const { data: prequal } = usePrequal();
  const { data: application } = useApplication();
  const documentId = application.attributes.final_loan.data.attributes.current_document.id;
  const [isSuccess, setIsSuccess] = useState(null);

  const onSubmit = () => ({ documentId });

  const onSuccess = () => {
    setIsSuccess(true);
    if (prequal.redirectUri) {
      // Case: External checkout, redirect back to merchant
    } else if (window.opener) {
      // Case: Widget, let the parent window know signing has occurred
      window.opener.postMessage('SIGNED', '*');
    } else {
      window.location.href = `/${process.env.PREFIX}/customers/${prequal.capsId}`;
    }
  };

  const mutationForm = useSWRMutationForm({
    useMutation: () => useSignDocument(documentId, { onSuccess }),
    onSubmit,
    useUnhandledError: useErrorToSnackbar,
  });

  return {
    isSuccess,
    ...mutationForm,
  };
};

export default useForm;
